import outlookSrc from '@corbado/shared-ui/assets/outlook.svg';
import React from 'react';
import { Icon } from './Icon';
export const OutlookIcon = props => {
    return (React.createElement(Icon, { src: outlookSrc, ...props }));
};
